import React, { useState } from 'react'
import downloadIcon from '../../../../assests/admin/guide/downloadIcon.png'
import excelIcon from '../../../../assests/admin/guide/excelIcon.png'
import { useDispatch, useSelector } from 'react-redux';
import classes from './ExcelDownloadBtn.module.css'
import { exportXlsx, submissionsApi } from '../../../../utils';
import { throwApiError } from '../../../lms-shared/store/error-handling-actions';


const ExcelDownloadBtn = ({ teacherUserId }) => {

    const texts = useSelector(state => state.translate.texts);
    const { applicationId } = useSelector(state => state.application);
    const [showMessage, setShowMessage] =useState(false)
    const dispatch = useDispatch()

    function downloadFunc() {

        let data = {
            limit: 10,
            applicationId: applicationId,
            teacherUserId: teacherUserId
        }
        submissionsApi.submissionsRandomReportPost({ submissionsRandomInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageTitleErrorOccurred, error: error, statusCode: response?.statusCode, message: "submissionsRandomRangeFilter " + error.message, level: 2, component: "AssessmentsGuide", line: 141 }))
            }
            else {
                if (response.body.length > 0)
                    exportFiles(response.body)
                else
                    setShowMessage(true)
            }
        })
    }


    const exportFiles = (csvData) => {

        // if (!csvData?.length) {
        //     setMsg(<div className={classes.DownloadMsg}> {texts.noDataToView}</div>)
        //     return
        // }
        let arr = [], filename, headerNames;
        if (csvData.length) {
            for (let i = 0; i < csvData.length; i++) {
                filename = csvData[i].name;
                headerNames = [...csvData[i].lesson.users[0].assessment.map(a => a.assessmentName)];
                arr = []
                csvData[i].lesson.users.forEach(u => {
                    let obj = {}
                    let flag = false
                    u.assessment.forEach((_a, index) => {
                        obj[index] = _a?.submission?.solution;
                        if (_a?.submission?.solution != null) flag = true
                    })
                    flag && arr.push(obj)
                })
                exportXlsx(filename, [headerNames], arr, true, true);
            }
        }

    }


    return (
        <div className={classes.ExcelContainer}>
            <div className={classes.ExcelBtnContainer}>
                <img className={classes.ExcelIcon} src={excelIcon} alt="excelIcon" />
                <div className={classes.DownloadIconContainer}>
                    <img className={classes.DownloadIcon} src={downloadIcon} onClick={downloadFunc} alt="downloadIcon" />
                </div>
            </div>
            <p className={classes.ExcelText}>{texts.viewingAnswersLessons}</p>
            {showMessage && <p className={classes.ExcelEmptyError}>{texts.noResultsToDownload}</p>}
        </div>
    )
}

export default ExcelDownloadBtn;